"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCriteriaTypeToJSON = exports.FilterCriteriaTypeFromJSONTyped = exports.FilterCriteriaTypeFromJSON = exports.FilterCriteriaType = void 0;
/**
 *
 * @export
 */
exports.FilterCriteriaType = {
    Include: 0,
    Exclude: 1,
    Invert: 2
};
function FilterCriteriaTypeFromJSON(json) {
    return FilterCriteriaTypeFromJSONTyped(json, false);
}
exports.FilterCriteriaTypeFromJSON = FilterCriteriaTypeFromJSON;
function FilterCriteriaTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.FilterCriteriaTypeFromJSONTyped = FilterCriteriaTypeFromJSONTyped;
function FilterCriteriaTypeToJSON(value) {
    return value;
}
exports.FilterCriteriaTypeToJSON = FilterCriteriaTypeToJSON;
